import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { CounterpartyAddress } from "@common/schemas/counterpartyAddress.schema";
import { CounterpartyContact } from "@common/schemas/counterpartyContact.schema";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

const TextCell = ({ value }: { value: string | null }) => (
    <ViewTableCell>{value ?? "-"}</ViewTableCell>
);

export const CounterpartyContactTextCell = memo(
    ({
        getValue,
    }: CellContext<ViewTableFeatures, CounterpartyContact, string | null>) => (
        <TextCell value={getValue()} />
    ),
);

export const CounterpartyAddressTextCell = memo(
    ({
        getValue,
    }: CellContext<ViewTableFeatures, CounterpartyAddress, string | null>) => (
        <TextCell value={getValue()} />
    ),
);

CounterpartyContactTextCell.displayName = "CounterpartyContactTextCell";
CounterpartyAddressTextCell.displayName = "CounterpartyAddressTextCell";
